module.exports = __webpack_public_path__ + "img/03.404bf9c4.png";